"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleSession = void 0;
const battle_1 = require("@creature-chess/battle");
const board_1 = require("@creature-chess/board");
const animationEventStore_1 = require("../components/game/board/piece/match/animationEventStore");
const creatureDefinitions_1 = require("../networking/creatureDefinitions");
class BattleSession {
    constructor(pieceRegistry, settings) {
        this.pieceRegistry = pieceRegistry;
        this.settings = settings;
        this.runner = null;
        this.board = new board_1.SubscribableBoard(settings.boardWidth, settings.boardHalfHeight * 2);
        this.combatStore = (0, battle_1.pieceInfoStore)();
        this.animationEventStore = new animationEventStore_1.PieceAnimationEventStore();
    }
    start(turn = 0) {
        var _a;
        (_a = this.runner) === null || _a === void 0 ? void 0 : _a.stop();
        const runner = new battle_1.BattleRunner(this.board, this.pieceRegistry, this.combatStore, (0, creatureDefinitions_1.getCreatureLookup)(), this.settings, turn, (events) => this.animationEventStore.pushEvents(events));
        this.runner = runner;
        return runner.run();
    }
    pause() {
        var _a;
        (_a = this.runner) === null || _a === void 0 ? void 0 : _a.pause();
    }
    resume() {
        var _a;
        (_a = this.runner) === null || _a === void 0 ? void 0 : _a.resume();
    }
}
exports.BattleSession = BattleSession;
